import { normalizeProfileUser } from './profile'
import { GET, POST } from './api'
import { ReadObject, SaveObject } from './storage'
import { RemoveWebPushToken } from './notifications'
import { trackEvent } from './analytics'
import { HydrateIdentitySessions } from './identity'
import { captureSessionState, isSessionStateCurrent, clearIdentitySessionData, beginSessionLogout } from './session'

const MVU_ESSENTIALS_SESSION_KEY = 'mvu_essentials'
const MVU_ACCELERATOR_SESSION_KEY = 'mvu_accelerator'

export const DoRegister = async params => {
	return await POST(`/auth/local/register`, params)
}

const authenticate = async (params, endpoint, key, portal) => {
  clearIdentitySessionData()
  const snapshot = captureSessionState()
  const response = await POST(endpoint, params)
  if (!isSessionStateCurrent(snapshot)) return false
  if (response?.jwt) {
    SaveObject(key, response)
    const signedIn = captureSessionState()
    await HydrateIdentitySessions()
    // Hydration may legitimately replace secondary tokens. Revision and the
    // verified source token still identify this login after that operation.
    if (captureSessionState().revision !== signedIn.revision || ReadObject(key)?.jwt !== response.jwt) return false
    if (portal) trackEvent('LOGIN', { portal, method: 'email' })
  }
  return response
}

export const MVUEssentialsDoLogin = params => authenticate(params, '/mvu-essentials-auth/login', MVU_ESSENTIALS_SESSION_KEY, 'essentials')
export const MVUAcceleratorDoLogin = params => authenticate(params, '/mvu-accelerator-auth/login', MVU_ACCELERATOR_SESSION_KEY, 'accelerator')
export const DoLogin = params => authenticate(params, '/auth/local', 'authentication')

export const DoLogout = async () => {
	beginSessionLogout()
	const snapshot = captureSessionState()
	await Promise.race([
		trackEvent('LOGOUT'),
		new Promise(resolve => setTimeout(resolve, 750)),
	])
	if (!isSessionStateCurrent(snapshot)) return true
	const webPushToken = ReadObject('web_push_token')
	if (webPushToken?.token) {
		try {
			await Promise.race([RemoveWebPushToken({ token: webPushToken.token }), new Promise(resolve => setTimeout(resolve, 1500))])
		} catch (error) {
			console.warn('Unable to remove web push token on logout.', error)
		}
	}
	if (isSessionStateCurrent(snapshot)) clearIdentitySessionData()
	return true
}

export const DoForgotPassword = async params => {
	return await POST(`/auth/forgot-password`, params)
}

export const DoResetPassword = async params => {
	return await POST(`/auth/reset-password`, params)
}

export const DoMVUEssentialsRegister = async params => {
	return await POST(`/mvu-essentials-auth/register`, params)
}

export const ValidateMVUEssentialsInvite = async code => {
	return await GET(`/mvu-essentials-auth/invite/${code}`, false)
}

export const DoMVUEssentialsForgotPassword = async params => {
	return await POST(`/mvu-essentials-auth/forgot-password`, params)
}

export const DoMVUEssentialsResetPassword = async params => {
	return await POST(`/mvu-essentials-auth/reset-password`, params)
}

export const DoMVUAcceleratorRegister = async params => {
	return await POST(`/mvu-accelerator-auth/register`, params)
}

export const ValidateMVUAcceleratorInvite = async code => {
	return await GET(`/mvu-accelerator-auth/invite/${code}`, false)
}

export const DoMVUAcceleratorForgotPassword = async params => {
	return await POST(`/mvu-accelerator-auth/forgot-password`, params)
}

export const DoMVUAcceleratorResetPassword = async params => {
	return await POST(`/mvu-accelerator-auth/reset-password`, params)
}

export const IsLogged = async () => {
	const authentication = ReadObject('authentication')
	return authentication?.jwt
}

export const ReadMe = async () => {
	return normalizeProfileUser(await GET(`/me`, true))
}

export const VerifyOtp = async params => {
	return await POST(`/auth/verify-otp`, params)
}

export const ResendOtp = async params => {
	return await POST(`/auth/resend-otp`, params)
}

export const FinalizePostVerifyEmails = async (params) => {
	// public endpoint — no auth header; must receive { email }
	return await POST(`/auth/finalize-post-verify-emails`, params)
}
